import React, { useState, useEffect } from 'react';

const DevPanel = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeProfile, setActiveProfile] = useState(null);

  // Load active profile from localStorage on mount
  useEffect(() => {
    const savedProfile = localStorage.getItem('simpleodds_test_profile');
    if (savedProfile) {
      setActiveProfile(savedProfile);
    }
  }, []);

  // Only show in development mode
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const testProfiles = [
    { value: '', label: 'No Test Profile (Real Data)' },
    { value: 'active', label: 'Active - Full access (paid)' },
    { value: 'trialing', label: 'Trialing - 1 game limit, expires in 2 days' },
    { value: 'past_due', label: 'Past Due - Downgraded to free tier' },
    { value: 'canceled_active', label: 'Canceled - Still valid for 15 days' },
    { value: 'expired', label: 'Expired - No access (paid)' },
    { value: 'trial_expired', label: 'Trial Expired - No access' },
    { value: 'no_subscription', label: 'No Subscription - Never subscribed' }
  ];

  const handleProfileChange = (profileValue) => {
    if (profileValue) {
      localStorage.setItem('simpleodds_test_profile', profileValue);
      setActiveProfile(profileValue);
    } else {
      localStorage.removeItem('simpleodds_test_profile');
      setActiveProfile(null);
    }

    // Reload page to apply new profile
    window.location.reload();
  };

  const getButtonColor = () => {
    if (!activeProfile) {
      return '#6c757d'; // Gray - no profile active
    }
    return '#FF6243'; // Orange - profile active
  };

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          background: getButtonColor(),
          border: '2px solid white',
          color: 'white',
          fontSize: '24px',
          fontWeight: 'bold',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          transition: 'all 0.2s ease',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.1)';
          e.target.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
        }}
        title={activeProfile ? `Active: ${activeProfile}` : 'Test Profiles'}
      >
        {activeProfile ? '🧪' : '⚙️'}
      </button>

      {/* Dropdown Panel */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            bottom: '90px',
            right: '20px',
            background: '#1e293b',
            border: '2px solid #334155',
            borderRadius: '12px',
            padding: '16px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.5)',
            zIndex: 9998,
            minWidth: '280px'
          }}
        >
          {/* Header */}
          <div style={{
            fontSize: '14px',
            fontWeight: '600',
            color: '#fff',
            marginBottom: '12px',
            paddingBottom: '12px',
            borderBottom: '1px solid #334155'
          }}>
            🧪 Test Profile Selector
          </div>

          {/* Active Profile Display */}
          {activeProfile && (
            <div style={{
              background: 'rgba(255, 98, 67, 0.1)',
              border: '1px solid #FF6243',
              borderRadius: '6px',
              padding: '8px 12px',
              marginBottom: '12px',
              fontSize: '12px',
              color: '#FF6243',
              fontWeight: '600'
            }}>
              Active: {testProfiles.find(p => p.value === activeProfile)?.label}
            </div>
          )}

          {/* Profile Dropdown */}
          <select
            value={activeProfile || ''}
            onChange={(e) => handleProfileChange(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: '13px',
              background: '#0f172a',
              border: '1px solid #334155',
              borderRadius: '6px',
              color: '#cbd5e1',
              cursor: 'pointer',
              marginBottom: '12px'
            }}
          >
            {testProfiles.map(profile => (
              <option key={profile.value} value={profile.value}>
                {profile.label}
              </option>
            ))}
          </select>

          {/* Info Text */}
          <div style={{
            fontSize: '11px',
            color: '#94a3b8',
            lineHeight: '1.4',
            marginBottom: '12px'
          }}>
            Test profile will be appended to all API calls. Page will reload when you select a profile.
          </div>

          {/* Close Button */}
          <button
            onClick={() => setIsOpen(false)}
            style={{
              width: '100%',
              padding: '8px',
              fontSize: '12px',
              fontWeight: '600',
              background: '#334155',
              border: 'none',
              borderRadius: '6px',
              color: '#cbd5e1',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#475569';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#334155';
            }}
          >
            Close
          </button>
        </div>
      )}
    </>
  );
};

export default DevPanel;
